<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
          <div class="padding">
          <p>When I got home I tried to find a map I might have made of the low areas by the water level, but all I could find was a note I made about being carried out of the water, but it wasn't mapped.</p>

    <p>Had I fallen in?</p>

    <p>Did you carry me out?</p>

    <p>could i really forget that, surely it's something I would relive often?</p>
          </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'Carry Me'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
